import React from 'react';
import { Outlet, Link, Navigate, useLocation } from 'react-router-dom';  // Import Outlet and Link from react-router-dom

import AgentHeader from '../components/AgentHeader';
import AgentSidebar from '../components/AgentSidebar';
import DashboardFooter from '../components/DashboardFooter';
// import { CartProvider } from 'components/CartContext';
import { Provider } from 'react-redux';
import store from '../../src/redux/store';
import { getAuthCookie, unauthenticatedLoginPath } from '../utils/authCookies';

interface LayoutProps {
    children?: React.ReactNode;  // Make children optional as we are using Outlet
}

const AgentLayout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  if (!getAuthCookie("sessionToken")) {
    return <Navigate to={unauthenticatedLoginPath(location.pathname, location.search)} replace />;
  }

  return (
    <Provider store={store}>
    <div id="layout-wrapper">
      {/* Header component */}
      <AgentHeader />
      
      {/* Sidebar component */}
      <AgentSidebar />

      {/* Main content area */}
      <div className="main-content me-0">
        <div className="page-content">
          <div className="container-fluid">
           
            {/* Render children or Outlet (child routes) */}
            {children ? children : <Outlet />}  {/* Render children if passed, else Outlet */}
          </div>
        </div>

        {/* Footer component */}
        <DashboardFooter />
      </div>
    </div>
    </Provider>
  );
};

export default AgentLayout;
